import * as types from '../mutation-types';
import gallery from '../../api/gallery';

const initialState = {
  selected: {
    type: Object,
    default: null,
  },
  pieces: {
    type: Object,
    default: null,
  },
  fetching: {
    type: Boolean,
    default: false,
  },
  fetchError: {
    type: Object,
    default: null,
  },
};

const actions = {
  fetch({ commit }) {
    commit(types.FETCH_GALLERY);
    gallery.fetch().then((response) => {
      commit(types.FETCH_GALLERY_SUCCESS, { data: response.data });
    }, (error) => {
      commit(types.FETCH_GALLERY_FAILURE, { error });
    });
  },
};

const mutations = {
  [types.FETCH_GALLERY](state) {
    state.fetching = true;
  },
  [types.FETCH_GALLERY_SUCCESS](state, { data }) {
    state.sections = data.sections;
  },
  [types.FETCH_GALLERY_FAILURE](state, { error }) {
    state.fetching = false;
    state.fetchError = error;
  },
};

export default {
  state: initialState,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/gallery.js